import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	timelineHeading: {
		id: 'business-timeline.timeline-view.timeline-heading',
		defaultMessage: 'Timeline',
		description: 'Heading of the timeline view',
	},
	inlineCreateErrorTitle: {
		id: 'business-timeline.timeline-view.inline-create-error-title',
		defaultMessage: 'Failed to create an item.',
		description: 'Error title when inline create in list failed',
	},
	inlineCreateErrorDescription: {
		id: 'business-timeline.timeline-view.inline-create-error-description',
		defaultMessage: 'We were not able to create the item. Try again with the create button.',
		description: 'Error description when inline create in list failed',
	},
	loadingMoreItems: {
		id: 'business-timeline.timeline-view.loading-more-items',
		defaultMessage: 'Loading more items...',
		description: 'Text used to show that more items are being loaded.',
	},
	createDependencyErrorTitle: {
		id: 'business-timeline.timeline-view.create-dependency-error-title',
		defaultMessage: "We couldn't link items.",
		description: 'Error title informing the user attempt at creating issue link failed.',
	},
	createDependencyErrorMessage: {
		id: 'business-timeline.timeline-view.create-dependency-error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message informing the user attempt at creating issue link failed.',
	},
	startDateMissingErrorTitle: {
		id: 'business-timeline.timeline-view.start-date-missing-error-title',
		defaultMessage: "We couldn't save the item.",
		description: 'Error message informing the user that updating the item failed',
	},
	startDateMissingErrorMessage: {
		id: 'business-timeline.timeline-view.start-date-missing-error-message',
		defaultMessage: "Field 'Start date' cannot be set. It is not on the appropriate screen.",
		description: 'Warning message when user does not set start date field in a project',
	},
});
